<!-- =========================================================================================
  File Name: UploadImageView.vue
  Description: Item Component - Grid VIew
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template slot="no-body">
<vs-popup class="uploder-pop" title=" "  :active.sync="MainUploadPopup" style="z-index: 530000 !important">
  <div class="vx-row">
    <div class="vx-col w-full">
  <div>
    <vs-tabs v-model="MainPopupTabIndex">
      <vs-tab label="Upload from PC" icon-pack="feather"  icon="icon-image" >
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <input type="file" class="hidden" multiple ref="uploadImageInput" @change="uploadNewImage" accept="image/*">
        <vs-button  icon-pack="feather" icon="icon-upload" @click.native="$refs.uploadImageInput.click()">Upload</vs-button>
        </vs-col>
      </vs-row>
      </vs-tab>
      <vs-tab label="Upload from ServerPath" icon-pack="feather"  icon="icon-folder">
              <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" >
                  <vs-input placeholder="Enter Path" class="is-label-placeholder inline-flex" v-model="dataPath"></vs-input><vs-button class="mt-5" @click.native="ServerUpload">Upload</vs-button>
                </vs-col>
               </vs-row>
      </vs-tab>
      <vs-tab label="Upload form FB" icon-pack="feather" icon="icon-facebook">
        <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <vs-button icon-pack="feather" icon="icon-facebook"   @click.native="login()">Login with Facebook</vs-button>
        </vs-col>
      </vs-row>
      </vs-tab>
    </vs-tabs>
  </div>
    </div>
  </div> 
  <vs-popup  title="Facebook Pages" :active.sync="FacebookPopup">
   <div class="vx-row mb-3">
    <div class="vx-col w-full">
      <label class="vs-select--label w-full">Select Page</label>
      <v-select  label="name" class="w-full" v-model="dataPage" @input="getAlbum()" multiple :closeOnSelect="true"  :options="FbPages"/>
    </div>
  </div>
   <div class="vx-row mb-3" v-if="dataPage.length > 0">
    <div class="vx-col">
    <label class="vs-select--label w-full">Select Album</label>
    <ul class="mt-3">
      <li v-for="album in FbAlbums" :key=album.id class="inline-flex">
        <vs-checkbox v-model="dataAlbum" @change="getPhotos()" :vs-value="album">{{album.name}}</vs-checkbox>
      </li>
    </ul>
    </div>
  </div>
  <div class="vx-row mb-3">
    <div class="vx-col w-full">
      <vs-button class="mr-3" @click.native="getFBImages()" :disabled="!(dataPage.length > 0 && dataAlbum.length > 0)">Get </vs-button>
      <vs-button class="mr-3" color="success" @click.native="SaveImages()" :disabled="!(FBImages.length > 0)">Save</vs-button>
    </div>
    <div class="vx-col w-full">
    </div>
  </div>
    <span v-for="img in FBImages" :key=img.id>
      <img :src="img.picture" alt="">
    </span>

</vs-popup>
</vs-popup>
            
            
</template>

<script>
import vSelect from 'vue-select'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Vue from 'vue'
Vue.use(Viewer)
import S3 from 'aws-s3'
const config = {
  bucketName: process.env.VUE_APP_AWS_BUCKET,
  dirName: 'ImageLibrary',
  region: process.env.VUE_APP_AWS_DEFAULT_REGION,
  accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
  s3Url: process.env.VUE_APP_AWS_s3Url
}
const S3Client = new S3(config)
import {
ADD_IMAGE_TO_LIBRARY,
GET_DIRECTORY_IMAGES,
SAVE_FB_IMAGES,
} from '@/graphql'
export default{
    components: {
   'v-select': vSelect,
  },

data () {
return {
 MainPopupTabIndex:0,
      activeLoading:false,
      dataPath:null,
      FB:{},
      appID:null,
      appSecret:null,
      FbPages:[],
      FbAlbums:[],
      FBPhotos:[],
      FBImages:[],
      FacebookPopup:false,
      dataPage:[],
      dataAlbum:[],
      MainUploadPopup:false
    }
  },
   watch: {
    upload:function (val) {
     if(val){
      this.MainUploadPopup=val
     }
   },    
   FacebookPopup:function (val) {
     if(!val){
      this.FbPages=[]
      this.FbAlbums=[]
      this.FBPhotos=[]
      this.FBImages=[]
      this.dataPage=[]
      this.dataAlbum=[]
     }
   },
    MainUploadPopup:function (val) {
      if(!val){
         this.dataPath=null
         this.MainPopupTabIndex=0
         this.FbPages=[]
          this.FbAlbums=[]
          this.FBPhotos=[]
          this.FBImages=[]
          this.dataPage=[]
          this.dataAlbum=[]
          this.$emit('closeUpload',false)
      }
    },
    },
  props: {
    upload: {
      type: Boolean,
      required: true
    }
  },
  methods: {
      SaveImages(){
        this.loader()
        this.$apollo
        .mutate({
          mutation: SAVE_FB_IMAGES,
          variables: {
            imgs: this.FBImages,
          }
        })
        .then(response => {
            if(response.data.saveFbImgs.status==='Success'){
                this.$vs.notify({
                  title: 'Images',
                  text: 'Facebook images save successfully',
                  color: 'success',
                  position: 'top-right'
                })
                   this.FacebookPopup=false
                   this.MainUploadPopup=false
            //       this.get()
                  this.activeLoading = false
                  this.$vs.loading.close()
                   this.$emit('getdata','fbfolder')
             }
    })
},  
 getFBImages(){
   let _this=this
   this.FBImages=[]
   for (let index = 0; index < this.FBPhotos.length; index++) {
          let photo_id = this.FBPhotos[index].id;
             FB.api('/'+photo_id+'?fields=images,picture,from,album',
              function (response) {
                if (response && !response.error) {
                    console.log(response)
                   _this.FBImages.push(response)
                }
              }
          );
        }
 },  
 getPhotos(){
        this.FBPhotos=[]
        for (let index = 0; index < this.dataAlbum.length; index++) {
          // console.log(this.dataAlbum[index])
          let album_id = this.dataAlbum[index].id;
          // let result = this.getPhotosFromAlbum('/'+album_id+'/photos')
          this.getPhotosFromAlbum('/'+album_id+'/photos')
        }
    },
getPhotosFromAlbum(link){
    let _this=this
     FB.api(
          link,
          function (response) {
            if (response && !response.error) {
             for (let photo = 0; photo < response.data.length; photo++) {
                _this.FBPhotos.push(response.data[photo]);
              }
              if(response.paging.next){
                _this.getPhotosFromAlbum(response.paging.next)
              }
            }
          }
      );
},
    getAlbum(){
        this.FbAlbums=[]
        for (let index = 0; index < this.dataPage.length; index++) {
          // console.log(this.dataPage[index])
          let page_id = this.dataPage[index].id;
          this.getAlbumFromPage('/'+page_id+'/albums')
        }
    },
    getAlbumFromPage(link){
    let _this=this
    FB.api(link,
            function (response) {
              if (response && !response.error) {
              for (let alb = 0; alb < response.data.length; alb++) {
                _this.FbAlbums.push(response.data[alb]);
              }
              if(response.paging.next){
                _this.getAlbumFromPage(response.paging.next)
              }
             }
            }
        );
    },
    login(){
      let _this = this
      // _this.FbLogout()
      FB.getLoginStatus(function(response) {
        // console.log(response)
        if(response.status === 'connected'){
          // console.log(response)
           localStorage.setItem('storedFbUserID', response.authResponse.userID)
           _this.getUserPage() 
          // _this.FbMeData();
        }
        else{
        FB.login(function(response){
         if(response.status === 'connected'){
          var appID= _this.appID
          var appSecret= _this.appSecret
          console.log(response)
          fetch('https://graph.facebook.com/oauth/access_token?client_id='+appID+'&client_secret='+appSecret+'&grant_type=fb_exchange_token&fb_exchange_token='+response.authResponse.accessToken).then(function(response) {
          return response.json();
        }).then(function(data) {
          localStorage.setItem('storedFbToken', data.access_token)
        }).catch(function() {
          console.log("Token Error");
        });
         }
         else{
           localStorage.removeItem('storedFbToken')
           localStorage.removeItem('storedFbUserID');
         }
         } ,{scope: 'public_profile,pages_show_list,pages_read_engagement'});
        }
         });
  
    },
    getUserPage(){
       let _this = this
      let user_id = localStorage.getItem('storedFbUserID');
          FB.api('/'+user_id+'/accounts',
          function (response) {
            if (response && !response.error) {
              _this.FbPages=response.data
              _this.FacebookPopup=true
            }
          }
        );    
    },
    FbLogout(){
      FB.logout(function(response) {
            console.log(response)
          });
    },
    FbMeData(){
        FB.api('/me', function(response) {
        if (response && !response.error){
        localStorage.setItem('storedFbUserName', response.name)
        // console.log('Successful login for: ' + response.name);
        }
        else{
          console.log(response.error)
        }
      //   });
      //   FB.api('/me/permissions', function(response) {
      //   console.log(response)
        });
        

    },

ServerUpload(){
  if(this.dataPath){
        this.loader()
        this.$apollo
        .mutate({
          mutation: GET_DIRECTORY_IMAGES,
          variables: {
                path: this.dataPath,
          }
        })
        .then(response => {
          console.log(response)
            if(response.data.getDirectoryImages.status==='Success'){
              //  for (let index = 0; index < response.data.getDirectoryImages.images.length; index++) {
              //     response.data.getDirectoryImages.images[index];
              // this.folders.unshift(response.data.getDirectoryImages.folder);
              //  }
                this.activeLoading = false
                this.$vs.loading.close()
                this.dataPath=null
                this.MainUploadPopup=false
                 this.$emit('getdata','folder')
            }
            else{
                  this.$vs.notify({
                  title: 'Directory',
                  text: 'Please Enter a valid path',
                  color: 'danger',
                  position: 'top-right'
                })
                this.activeLoading = false
                this.$vs.loading.close()
                 this.dataPath=null
                // this.MainUploadPopup=false
            }
       
          })
  }else{
        this.$vs.notify({
        title: 'Directory',
        text: 'Path is required!',
        color: 'danger',
        position: 'top-right'
      })
  }
},
loader () {
  this.activeLoading = true
  this.$vs.loading({
  type:'sound'
  })
},  
    SaveFile (response, orignal_name) {

      if (response) {
        var key = response.key
        var location = response.location
        this.$apollo
        .mutate({
          mutation: ADD_IMAGE_TO_LIBRARY,
          variables: {
                name: orignal_name,
                key: key,
                url: location,
                folder:'0'
          }
        })
        .then(response => {
            if(response.data.addImageToLibrary.status==='Success'){
               this.$emit('getdata','image')
              //  this.images.unshift({
              //    'id':response.data.addImageToLibrary.color,
              //    'name':orignal_name,
              //     'key':key,
              //     'url':location,
              //      'folder':'0',
              //      'check':false,
              //      'created_at':response.data.addImageToLibrary.message
              //  });
             }
                this.MainUploadPopup=false
                this.activeLoading = false
                this.$vs.loading.close()

             
        }
        )

      }
    //   console.log(this.uplodedfiles)

    },
    uploadNewImage () {
      this.loader()
      for (let i = 0; i < this.$refs.uploadImageInput.files.length; i++) {
          const file = this.$refs.uploadImageInput.files[i]
          const orignal_name = this.$refs.uploadImageInput.files[i].name
          const name = Math.random().toString().slice(2)
        //   this.openLoadingInDiv()
          S3Client
            .uploadFile(file, name)
            .then(response => {
                console.log(response)
            //   this.$vs.loading.close('#div-with > .con-vs-loading')
              this.SaveFile(response, orignal_name)
            })
            .catch(err => console.error(err))
      }

    },

  },
      mounted () {
    let _this = this
    this.$nextTick(() => {
      window.fbAsyncInit = function () {
        FB.init({
          appId: process.env.VUE_APP_FB_APP_ID,
          xfbml: true,
          version: 'v2.6'
        })
        FB.AppEvents.logPageView()
        _this.FB = FB
        console.log('FB SDK was initialized as mixin')
      };
      (function (d, s, id) {
        let js, fjs = d.getElementsByTagName(s)[0]
        if (d.getElementById(id)) { return }
        js = d.createElement(s); js.id = id
        js.src = '//connect.facebook.net/en_US/sdk.js'
        fjs.parentNode.insertBefore(js, fjs)
      }(document, 'script', 'facebook-jssdk'))
    })
  },

  created () {
    this.appID=process.env.VUE_APP_FB_APP_ID  
    this.appSecret=process.env.VUE_APP_FB_APP_SECRET_ID
    this.img_cdn=process.env.VUE_APP_IMAGES_CDN_LINK
    this.img_cdn=this.img_cdn.replace('/images','');
  },
}
</script>

